<template>
    <div>
        <div class="row">
            <div class="col-md-12 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-clock-o"></i>
                            Demande de rendez-vous
                            <hr>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Adresse du rendez-vous</label>
                                <input type="text"
                                    class="form-control pa50px"
                                    disabled
                                    :value="formattedAddress">
                            </div>
                        </div>
                    </div>
                    <div class="row mt20 centerText">
                        
                        <div class="form-group centerText">
                            <label>Veuillez sélectionner le lieu du rendez-vous</label>
                        </div>
                        <div class="flexbox-container width400px height175px pa0 boxShadow cursorPointer partnerBox"
                            :class="[meetingRequestInfos.expertisePartnerRadio === 'carizy' ? (entity === 'renault' ? 'yellowBorders' : 'blueBorders') : 'greyBorders']"
                            @click="setExpert('carizy')"
                        >
                            <div class="part2 centerText whiteBackground">
                                <div class="icon45">
                                    <i class="fa fa-home"></i>
                                </div>
                                <div>
                                    <p class="text17px">Un inspecteur se déplacera <br> gratuitement au</p>
                                    <h4 class="text17px">{{ formattedAddress }}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt50" v-show="meetingRequestInfos.expertisePartnerRadio === 'carizy'">
                        <label class="greenLabel">1er créneau</label>
                        <div class="row">
                            <div class="form-group col-md-4"
                                id="first_time_slot_date"
                            >
                                <label>Date</label>
                                <div class="input-group date">
                                    <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                                    <input type="text"
                                        id="firstTimeSlotDate"
                                        class="form-control"
                                        placeholder="Sélectionner une date"
                                    >
                                </div>
                            </div>
                            <div class="col-md-4"
                                :class="{'has-error': errorFirstTimeSlotTimeRange}"
                            >
                                <label class="mb14">Heure de début</label>
                                <select v-model="meetingRequestInfos.firstTimeSlot.timeFrom"
                                        class="form-control border-none"
                                        :disabled="!meetingRequestInfos.firstTimeSlot.date"
                                >
                                    <option disabled value="">Sélectionner une heure de début</option>
                                    <option v-for="option in carizyInspectorFirstTimeSlotFromOptions"
                                            :key="option.value"
                                            :value="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4"
                                :class="{'has-error': errorFirstTimeSlotTimeRange}"
                            >
                                <label class="mb14">Heure de fin</label>
                                <select v-model="meetingRequestInfos.firstTimeSlot.timeTo"
                                        class="form-control border-none"
                                        :disabled="!meetingRequestInfos.firstTimeSlot.timeFrom"
                                >
                                    <option disabled value="">Sélectionner une heure de fin</option>
                                    <option v-for="option in carizyInspectorFirstTimeSlotToOptions"
                                            :key="option.value"
                                            :value="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <p v-if="errorFirstTimeSlotTimeRange"
                        class="text-error"
                        >
                            L'heure de fin doit être 1 heure après l'heure de début
                        </p>
                        <hr>
                        <label class="greenLabel">2ème créneau</label>
                        <div class="row">
                            <div class="form-group col-md-4"
                                id="second_time_slot_date"
                            >
                                <label>Date</label>
                                <div class="input-group date">
                                    <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                                    <input type="text"
                                        id="secondTimeSlotDate"
                                        class="form-control"
                                        placeholder="Sélectionner une date"
                                    >
                                </div>
                            </div>
                            <div class="col-md-4"
                                :class="{'has-error': errorSecondTimeSlotTimeRange}"
                            >
                                <label class="mb14">Sélectionner une heure de début</label>
                                <select v-model="meetingRequestInfos.secondTimeSlot.timeFrom"
                                        class="form-control border-none"
                                        :disabled="!meetingRequestInfos.secondTimeSlot.date"
                                >
                                    <option disabled value="">Sélectionner une heure de début</option>
                                    <option v-for="option in carizyInspectorSecondTimeSlotFromOptions"
                                            :key="option.value"
                                            :value="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4"
                                :class="{'has-error': errorSecondTimeSlotTimeRange}"
                            >
                                <label class="mb14">Sélectionner une heure de fin</label>
                                <select v-model="meetingRequestInfos.secondTimeSlot.timeTo"
                                        class="form-control border-none"
                                        :disabled="!meetingRequestInfos.secondTimeSlot.timeFrom"
                                >
                                    <option disabled value="">Sélectionner une heure de fin</option>
                                    <option v-for="option in carizyInspectorSecondTimeSlotToOptions"
                                            :key="option.value"
                                            :value="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <p v-if="errorSecondTimeSlotTimeRange"
                        class="text-error"
                        >
                            L'heure de fin doit être 1 heure après l'heure de début
                        </p>
                    </div>
                    <div class="row mt20 centerText"
                            :class="{ 'sk-loading': createAppraisalIsLoading }"
                            v-if="meetingRequestInfos.expertisePartnerRadio"
                        >
                            <spinner-double-bounce :displayNone="!createAppraisalIsLoading"/>

                            <p class="text17px" v-if="meetingRequestInfos.expertisePartnerRadio === 'carizy'">
                                En enregistrant, la demande de rendez-vous sera transmise aux inspecteurs partenaires du secteur.
                            </p>
                            <button
                                    @click="createAppraisal"
                                    v-if="!createAppraisalIsLoading"
                                    type="button"
                                    class="btn buttonLarge"
                                    :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
                                    :disabled="disableGoToNextStep"
                            >
                                Enregistrer le rendez-vous
                            </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pa17">
            <button
                    @click="goToPreviousStep"
                    type="button"
                    class="pull-left btn btn-w-m"
                    :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
            >
                Précédent
            </button>
        </div>
    </div>
</template>


<script>
    import gql from 'graphql-tag'
    import SpinnerDoubleBounce from '@/components/spinners/SpinnerDoubleBounce'
    import Alert from '@/components/Alert.vue'

    export default {
        name: "MeetingRequest",

        components: {
            SpinnerDoubleBounce,
            'component-alert': Alert
        },

        props: {
            activeStep: {
                type: Number,
                required: true
            },
            entity: {
                type: String,
                required: true
            },
            vehicle: {
                type: Object
            },
            quotation: {
                type: Object,
            },
            vehicleInfosProp: {
                type: Object
            },
            estimationInfosProp: {
                type: Object
            },
            sellerInfosProp: {
                type: Object
            },
            meetingRequestInfosProp: {
                type: Object
            },
            userInfos: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            autoSave: null,
            createAppraisalIsLoading: false,
            meetingRequestInfos: {
                expertisePartnerRadio: "",
                firstTimeSlot: {
                    date: "",
                    timeFrom: "",
                    timeTo: "",
                    idTech: ""
                },
                secondTimeSlot: {
                    date: "",
                    timeFrom: "",
                    timeTo: ""
                }
            },
            customerFormattedData: {
                optInCarizySMS: false,
                optInCarizyMail: false,
                formattedBirthDate: ""
            },
            customerId: "",
            quotationId: "",
            carId: "",
            appraisalId: "",
            carOwnerId: "",
            carizyInspectorTimeSlotOptions: {
                firstSlot: {
                    start: [],
                    end: [],
                },
                secondSlot: {
                    start: [],
                    end: [],
                },
            }
        }),

        computed: {
            formattedAddress () {
                return this.vehicleInfosProp.address.address + ", " + this.vehicleInfosProp.address.zipCode + ", " + this.vehicleInfosProp.address.city
            },
            inspectorCalendarToJSON () {
                if (this.vehicleInfosProp.availablePartners.inspector && this.vehicleInfosProp.availablePartners.inspector.calendar) {
                    let object = JSON.parse(this.vehicleInfosProp.availablePartners.inspector.calendar)
                    return object.result
                } else {
                    return null
                }
            },
            carizyInspectorFirstTimeSlotFromOptions () {
                return this.carizyInspectorTimeSlotOptions.firstSlot.start
            },
            carizyInspectorSecondTimeSlotFromOptions () {
                return this.carizyInspectorTimeSlotOptions.secondSlot.start
            },
            carizyInspectorFirstTimeSlotToOptions () {
                let filteredArray = []
                if (this.meetingRequestInfos.firstTimeSlot.timeFrom) {
                    this.meetingRequestInfos.firstTimeSlot.timeTo = ""
                    let a = moment.duration(this.meetingRequestInfos.firstTimeSlot.timeFrom)
                    let b = this.carizyInspectorTimeSlotOptions.firstSlot.end
                    filteredArray = this.filterTimeSlotToOptions(a, b)
                }
                return filteredArray
            },
            carizyInspectorSecondTimeSlotToOptions () {
                let filteredArray = []
                if (this.meetingRequestInfos.secondTimeSlot.timeFrom) {
                    this.meetingRequestInfos.secondTimeSlot.timeTo = ""
                    let a = moment.duration(this.meetingRequestInfos.secondTimeSlot.timeFrom)
                    let b = this.carizyInspectorTimeSlotOptions.secondSlot.end
                    filteredArray = this.filterTimeSlotToOptions(a, b)
                }
                return filteredArray
            },
            errorFirstTimeSlotTimeRange () {
                if (this.meetingRequestInfos.firstTimeSlot.timeFrom && this.meetingRequestInfos.firstTimeSlot.timeTo) {
                        let a = moment.duration(this.meetingRequestInfos.firstTimeSlot.timeFrom)
                        let b = moment.duration(this.meetingRequestInfos.firstTimeSlot.timeTo)
                        if (b.subtract(a).hours() < 1) {
                            return true
                        } else {
                            return false
                        }
                } else {
                    return false
                }
            },
            errorSecondTimeSlotTimeRange () {
                if (this.meetingRequestInfos.secondTimeSlot.timeFrom && this.meetingRequestInfos.secondTimeSlot.timeTo) {
                        let a = moment.duration(this.meetingRequestInfos.secondTimeSlot.timeFrom)
                        let b = moment.duration(this.meetingRequestInfos.secondTimeSlot.timeTo)
                        if (b.subtract(a).hours() < 1) {
                            return true
                        } else {
                            return false
                        }
                } else {
                    return false
                }
            },
            disableGoToNextStep () {
                if (
                    !this.meetingRequestInfos.firstTimeSlot.date ||
                    !this.meetingRequestInfos.firstTimeSlot.timeFrom ||
                    !this.meetingRequestInfos.firstTimeSlot.timeTo
                ) {
                   return true
                } else if (
                    this.meetingRequestInfos.expertisePartnerRadio === 'carizy' &&

                    (!this.meetingRequestInfos.secondTimeSlot.date ||
                    !this.meetingRequestInfos.secondTimeSlot.timeFrom ||
                    !this.meetingRequestInfos.secondTimeSlot.timeTo ||

                    this.errorFirstTimeSlotTimeRange ||
                    this.errorSecondTimeSlotTimeRange)
                ) {
                    return true
                } else {
                    return false
                }
            },
            customerMutation(){
                return gql`
                    mutation {
                    customer (
                        id: "${this.quotation.customer.id}",
                        firstName: "${this.sellerInfosProp.seller.firstName}",
                        lastName: "${this.sellerInfosProp.seller.lastName}",
                        birthDate: "${this.customerFormattedData.formattedBirthDate}",
                        email: "${this.sellerInfosProp.seller.email}",
                        phone: "${this.sellerInfosProp.seller.phone}",
                        civility: "${this.sellerInfosProp.seller.civility}",
                        address: {
                            address: "${this.sellerInfosProp.seller.address.address}",
                            city: "${this.sellerInfosProp.seller.address.city}",
                            zipCode: "${this.sellerInfosProp.seller.address.zipCode}",
                        }
                        optInCarizySMS: ${this.customerFormattedData.optInCarizySMS},
                        optInCarizyMail: ${this.customerFormattedData.optInCarizyMail},
                        optInPartner: ${this.sellerInfosProp.seller.marketingPartnerRadio},
                        coordinate: {
                          latitude: ${this.sellerInfosProp.seller.coordinate.latitude},
                          longitude: ${this.sellerInfosProp.seller.coordinate.longitude},
                        }
                        ) {
                        id
                        status
                        result
                        }
                    }`
            },
            customerMutationWithoutId(){
                return gql`
                    mutation {
                    customer (
                        firstName: "${this.sellerInfosProp.seller.firstName}",
                        lastName: "${this.sellerInfosProp.seller.lastName}",
                        birthDate: "${this.customerFormattedData.formattedBirthDate}",
                        email: "${this.sellerInfosProp.seller.email}",
                        phone: "${this.sellerInfosProp.seller.phone}",
                        civility: "${this.sellerInfosProp.seller.civility}",
                        address: {
                            address: "${this.sellerInfosProp.seller.address.address}",
                            city: "${this.sellerInfosProp.seller.address.city}",
                            zipCode: "${this.sellerInfosProp.seller.address.zipCode}",
                        }
                        optInCarizySMS: ${this.customerFormattedData.optInCarizySMS},
                        optInCarizyMail: ${this.customerFormattedData.optInCarizyMail},
                        optInPartner: ${this.sellerInfosProp.seller.marketingPartnerRadio},
                        coordinate: {
                          latitude: ${this.sellerInfosProp.seller.coordinate.latitude},
                          longitude: ${this.sellerInfosProp.seller.coordinate.longitude},
                        }
                        ) {
                        id
                        status
                        result
                        }
                    }`
            },
            addCarOwnerMutation(){
                let formattedBirthDate = ""
                if(this.sellerInfosProp.owner.dateOfBirth){
                    formattedBirthDate =  moment(this.sellerInfosProp.owner.dateOfBirth, "DD/MM/YYYY").format("YYYY-MM-DD")
                }

                let isOwner = false
                let hasCoOwner = false
                let isSellerCoOwner = false
                let isSellerPro = false

                if(this.sellerInfosProp.isSellerOwner === "yes") {
                    isOwner = true
                }
                if(this.sellerInfosProp.hasCoOwner === "yes") {
                    hasCoOwner = true
                }
                if(this.sellerInfosProp.isSellerCoOwner === "yes") {
                    isSellerCoOwner = true
                }
                if(this.sellerInfosProp.isProfessional === "yes") {
                    isSellerPro = true
                }

                return  gql`
                    mutation {
                    addCarOwner (
                        input: {
                            isOwner: ${isOwner},
                            hasCoOwner: ${hasCoOwner},
                            isSellerCoOwner: ${isSellerCoOwner},
                            isSellerPro: ${isSellerPro},
                            companyName: "${this.sellerInfosProp.owner.companyName}",
                            siretNumber: "${this.sellerInfosProp.owner.siretNumber}",
                            owner: {
                                address: {
                                    address: "${this.sellerInfosProp.owner.address.address}",
                                    city: "${this.sellerInfosProp.owner.address.city}",
                                    zipCode: "${this.sellerInfosProp.owner.address.zipCode}",
                                },
                                birthDate: "${formattedBirthDate}",
                                civility: "${this.sellerInfosProp.owner.civility}"
                                firstName: "${this.sellerInfosProp.owner.firstName}",
                                lastName: "${this.sellerInfosProp.owner.lastName}",
                            }
                        }
                    ) {
                        carOwner {
                            id
                        }
                    }
                    }`
            },
            updateCarRegistrationMutation(){
                let carId = ""
                if(this.quotation && this.quotation.car && this.quotation.car.id){
                    carId = this.quotation.car.id
                } else {
                    carId = this.carId
                }
                return  gql`
                    mutation {
                    updateCarRegistration (
                        carId: "${carId}",
                        lastNameOwner: "${this.sellerInfosProp.owner.lastName}",
                        firstNameOwner: "${this.sellerInfosProp.owner.firstName}",
                        address: "${this.sellerInfosProp.owner.address.address}",
                        city: "${this.sellerInfosProp.owner.address.city}",
                        zipCode: "${this.sellerInfosProp.owner.address.zipCode}",
                        formulaNumber: "${this.vehicleInfosProp.formulaNumber}"
                    ) {
                        result
                    }
                    }`
            },
            addTransactionSellerMutation(){
                let adId = ""
                return  gql`
                    mutation {
                    addTransactionSeller (
                        input: {
                            customerId: "${this.customerId}",
                            carOwnerId: "${this.carOwnerId}",
                            appraisalId: "${this.appraisalId}",
                            adId: "${adId}"
                        }
                    ) {
                        id
                    }
                    }`
            },
            addQuotationMutation(){
                let monthMEC = this.vehicle.monthMEC.charAt(0).toUpperCase() + this.vehicle.monthMEC.slice(1)
                return  gql`
                    mutation {
                    addQuotation (
                        realm: "${this.entity}",
                        make: ${this.vehicle.make.id},
                        model: ${this.vehicle.model.id},
                        year: ${this.vehicle.yearMEC},
                        month: "${monthMEC}",
                        fuel: "${this.vehicle.fuel.name}",
                        gear: "${this.vehicle.gearType.name}",
                        doors: ${this.vehicle.doors.name},
                        version: "${this.vehicle.version.name}",
                        versionId: "${this.vehicle.version.id}",
                        kilometer: ${this.vehicle.kilometer},
                        zipcode: "${this.vehicle.address.zipCode}",
                        licensePlate: "${this.vehicle.licensePlate}",
                        promoCode: "${this.estimationInfosProp.promoCode}",
                        customer: {
                            firstname: "${this.sellerInfosProp.seller.firstName}",
                            lastname: "${this.sellerInfosProp.seller.lastName}",
                            email: "${this.sellerInfosProp.seller.email}",
                            phone: "${this.sellerInfosProp.seller.phone}",
                        }
                        ) {
                        status
                        message
                        quotation {
                            id
                            car {
                                id
                            }
                        }
                        }
                    }`
            },
            customerProjectSellQuestionsMutation(){
                let valuationId = ""
                if(this.quotation && this.quotation.id){
                    valuationId = this.quotation.id
                } else {
                    valuationId = this.quotationId
                }

                let vehicleInspection = false
                let vehicleInspectionLessThanSixMonths = false
                let lastVehicleInspection = false
                let frenchCar = false
                let invoice = false
                let purchaseProject = "none"
                let isCarRegistrationOldMoreThanSixMonths = false
                let isVehicleFree = false
                let newMaintenance = false

                if(this.vehicleInfosProp.technicalControl2YearsRadio === "yes") {
                    vehicleInspection = true
                }

                if(this.vehicleInfosProp.technicalControl6MonthsRadio === "yes") {
                    vehicleInspectionLessThanSixMonths = true
                }

                if(this.vehicleInfosProp.revisionRadio === "yes") {
                    lastVehicleInspection = true
                }

                if(this.vehicleInfosProp.frenchRadio === "yes") {
                    frenchCar = true
                }

                if(this.vehicleInfosProp.importedInvoiceRadio === "yes") {
                    invoice = true
                }

                if(this.vehicleInfosProp.wishToBuyANewCarRadio === "yes") {
                    if(this.vehicleInfosProp.newVehicleCheckbox && this.vehicleInfosProp.secondHandVehicleCheckbox){
                        purchaseProject = "both"
                    } else if(this.vehicleInfosProp.newVehicleCheckbox){
                        purchaseProject = "new"
                    } else if(this.vehicleInfosProp.secondHandVehicleCheckbox){
                        purchaseProject = "used"
                    }
                }

                if(this.vehicleInfosProp.lastImmatOlderThan6MonthsRadio === "yes") {
                    isCarRegistrationOldMoreThanSixMonths = true
                }

                if(this.vehicleInfosProp.freeRadio === "yes") {
                    isVehicleFree = true
                }

                if(this.vehicleInfosProp.bodyRadio === "yes") {
                    newMaintenance = true
                }

                return gql`
                    mutation {
                    customerProjectSellQuestions (
                        valuationId: "${valuationId}",
                        vehicleInspection: ${vehicleInspection},
                        vehicleInspectionLessThanSixMonths: ${vehicleInspectionLessThanSixMonths},
                        lastVehicleInspection: ${lastVehicleInspection},
                        frenchCar: ${frenchCar},
                        invoice: ${invoice},
                        purchaseProject: "${purchaseProject}",
                        formulaNumber: "${this.vehicleInfosProp.formulaNumber}",
                        comment: "${this.vehicleInfosProp.comment}",
                        isCarRegistrationOldMoreThanSixMonths: ${isCarRegistrationOldMoreThanSixMonths},
                        isVehicleFree: ${isVehicleFree},
                        agreementExclusive: ${this.estimationInfosProp.exclusivityCheckbox},
                        agreementSellerPrice: ${this.estimationInfosProp.sellerPriceCheckbox},
                        newMaintenance: ${newMaintenance}
                        ) {
                        message
                        }
                    }`
            },
            addAppraisalFromBackofficeMutationCarizyInspector(){
                let valuationId = ""
                if(this.quotation && this.quotation.id){
                    valuationId = this.quotation.id
                } else {
                    valuationId = this.quotationId
                }

                const comment = this.estimationInfosProp.comment + " " + this.vehicleInfosProp.comment

                let formattedFirstTimeSlotDate = moment(this.meetingRequestInfos.firstTimeSlot.date, "DD/MM/YYYY").format("YYYY-MM-DD")
                let formattedSecondTimeSlotDate = moment(this.meetingRequestInfos.secondTimeSlot.date, "DD/MM/YYYY").format("YYYY-MM-DD")

                return  gql`
                    mutation {
                    addAppraisalFromBackoffice (
                        input: {
                            valuationId: "${valuationId}",
                            appraisal: {
                                comment: "${comment}",
                                address: "${this.vehicleInfosProp.address.address}",
                                city: "${this.vehicleInfosProp.address.city}",
                                zipCode: "${this.vehicleInfosProp.address.zipCode}",
                                addressType: "${this.vehicleInfosProp.addressRadio}",
                            },
                            timeSlots: [
                                {
                                    date: "${formattedFirstTimeSlotDate}",
                                    slotStart: "${this.meetingRequestInfos.firstTimeSlot.timeFrom}",
                                    slotEnd: "${this.meetingRequestInfos.firstTimeSlot.timeTo}",
                                },
                                {
                                    date: "${formattedSecondTimeSlotDate}",
                                    slotStart: "${this.meetingRequestInfos.secondTimeSlot.timeFrom}",
                                    slotEnd: "${this.meetingRequestInfos.secondTimeSlot.timeTo}",
                                }
                            ]
                        }
                        ) {
                        status
                        message
                        appraisal {
                            id
                        }
                        }
                    }`
            }
        },

        beforeDestroy () {
            clearInterval(this.autoSave)
        },

        created () {
            this.autoSaveData()
        },

        methods: {
            scrollToTop() {
                window.scrollTo(0,0);
            },
            autoSaveData () {
                this.autoSave = setInterval(() => {
                    this.$emit('pass-meeting-request-infos-data', this.meetingRequestInfos)
                }, 1000)
            },
            goToPreviousStep () {
                clearInterval(this.autoSave)
                this.$emit('go-to-previous-step', 4)
            },
            goToNextStep () {
                clearInterval(this.autoSave)
                this.$emit('pass-meeting-request-infos-data', this.meetingRequestInfos)
                this.$emit('go-to-next-step', 6)
            },
            setExpert (expert) {
                this.meetingRequestInfos.expertisePartnerRadio = expert
                this.resetFirstTimeSlot()
                this.resetSecondTimeSlot()
            },
            resetFirstTimeSlot () {
                this.meetingRequestInfos.firstTimeSlot = {
                    date: "",
                    timeFrom: "",
                    timeTo: "",
                    idTech: ""
                }
                $('#firstTimeSlotDate').val("")
            },
            resetSecondTimeSlot () {
                this.meetingRequestInfos.secondTimeSlot = {
                    date: "",
                    timeFrom: "",
                    timeTo: ""
                }
                $('#secondTimeSlotDate').val("")
            },
            createAppraisal () {
                // CREATE OR UPDATE CUSTOMER
                this.createOrUpdateCustomer()

                // NEXT STEP: CREATE QUOTATION IF NEEDED OR/AND SAVE MORE THINGS (see createOrUpdateCustomer())
            },
            async createOrUpdateCustomer () {
                this.createAppraisalIsLoading = true

                this.customerFormattedData.optInCarizySMS = this.sellerInfosProp.seller.marketingSmsCheckbox
                if(this.sellerInfosProp.seller.marketingSmsCheckbox === ""){
                  this.customerFormattedData.optInCarizySMS = false
                }

                this.customerFormattedData.optInCarizyMail = this.sellerInfosProp.seller.marketingEmailCheckbox
                if(this.sellerInfosProp.seller.marketingEmailCheckbox === ""){
                  this.customerFormattedData.optInCarizyMail = false
                }

                if(this.sellerInfosProp.seller.dateOfBirth){
                    this.customerFormattedData.formattedBirthDate =  moment(this.sellerInfosProp.seller.dateOfBirth, "DD/MM/YYYY").format("YYYY-MM-DD")
                }

                if(this.quotation && this.quotation.customer && this.quotation.customer.id){
                    this.$apollo.mutate({
                        mutation: this.customerMutation
                    }).then(response => {
                        this.customerId = response.data.customer.id
                        this.showBanner('success', 'Le customer a bien été créé ou mis à jour')
                        this.createAppraisalIsLoading = false

                        // NEXT STEP: CREATE QUOTATION IF NEEDED AND/OR SAVE MORE THINGS
                        if(!this.quotation.id){
                            this.createQuotation()
                        } else {
                            this.saveCustomerProjectSellQuestions()
                        }
                    }, () => {
                        this.showBanner('danger', 'Désolé, un problème est survenu lors de la création ou de la mise à jour du customer')
                        this.createAppraisalIsLoading = false
                    })
                } else {
                    this.$apollo.mutate({
                        mutation: this.customerMutationWithoutId
                    }).then(response => {
                        this.customerId = response.data.customer.id
                        this.showBanner('success', 'Le customer a bien été créé ou mis à jour')
                        this.createAppraisalIsLoading = false

                        // NEXT STEP: CREATE QUOTATION IF NEEDED AND/OR SAVE MORE THINGS
                        if(!this.quotation.id){
                            this.createQuotation()
                        } else {
                            this.saveCustomerProjectSellQuestions()
                        }
                    }, () => {
                        this.showBanner('danger', 'Désolé, un problème est survenu lors de la création ou de la mise à jour du customer')
                        this.createAppraisalIsLoading = false
                    })
                }
            },
            async createCarOwner () {
                this.createAppraisalIsLoading = true

                this.$apollo.mutate({
                    mutation: this.addCarOwnerMutation
                }).then(response => {
                    this.carOwnerId = response.data.addCarOwner.carOwner.id
                    this.showBanner('success', 'Le carOwner a bien été créé')
                    this.createAppraisalIsLoading = false

                    // NEXT STEP:
                    this.createTransactionSeller()
                }, () => {
                    this.showBanner('danger', 'Désolé, un problème est survenu lors de la création du carOwner')
                    this.createAppraisalIsLoading = false
                })
            },
            async createTransactionSeller () {
                this.createAppraisalIsLoading = true

                this.$apollo.mutate({
                    mutation: this.addTransactionSellerMutation
                }).then(response => {
                    this.showBanner('success', 'La transaction seller a bien été créée')
                    this.createAppraisalIsLoading = false

                    // NEXT STEP:
                    this.goToNextStep()
                }, () => {
                    this.showBanner('danger', 'Désolé, un problème est survenu lors de la création de la transaction seller')
                    this.createAppraisalIsLoading = false
                })
            },
            async createQuotation () {
                this.createAppraisalIsLoading = true

                this.$apollo.mutate({
                    mutation: this.addQuotationMutation
                }).then(response => {
                    this.quotationId = response.data.addQuotation.quotation.id
                    this.carId = response.data.addQuotation.quotation.car.id
                    this.showBanner('success', 'La cote a bien été créée')
                    this.createAppraisalIsLoading = false

                    // NEXT STEP:
                    this.saveCustomerProjectSellQuestions()
                }, () => {
                    this.showBanner('danger', 'Désolé, un problème est survenu lors de la création de la cote')
                    this.createAppraisalIsLoading = false
                })
            },
            async editCarRegistration () {
                this.createAppraisalIsLoading = true

                this.$apollo.mutate({
                    mutation: this.updateCarRegistrationMutation
                }).then(response => {
                    this.showBanner('success', 'Les infos du véhicule ont bien été mises à jour')
                    this.createAppraisalIsLoading = false
                }, () => {
                    this.showBanner('danger', 'Désolé, un problème est survenu lors de la mises à jour des infos du véhicule')
                    this.createAppraisalIsLoading = false
                })
            },
            async saveCustomerProjectSellQuestions () {
                this.createAppraisalIsLoading = true

                this.$apollo.mutate({
                    mutation: this.customerProjectSellQuestionsMutation
                }).then(response => {
                    this.showBanner('success', 'Les questions de qualifications ont bien été renseignées')
                    this.createAppraisalIsLoading = false

                    // NEXT STEP:
                    this.createAppraisalMutation()
                }, () => {
                    this.showBanner('danger', 'Désolé, un problème est survenu lors de la sauvegarde des questions de qualifications')
                    this.createAppraisalIsLoading = false
                })
            },
            async createAppraisalMutation () {
                this.createAppraisalIsLoading = true

                this.$apollo.mutate({
                  mutation: this.addAppraisalFromBackofficeMutationCarizyInspector
                }).then(response => {
                  this.appraisalId = response.data.addAppraisalFromBackoffice.appraisal.id
                  this.showBanner('success', 'Le RDV d\'expertise bien été créé')
                  this.createAppraisalIsLoading = false

                  // NEXT STEP
                  this.createCarOwner()
                  this.editCarRegistration()
                }, () => {
                  this.showBanner('danger', 'Désolé, un problème est survenu lors de la création du RDV d\'expertise')
                  this.createAppraisalIsLoading = false
                })

            },
            filterTimeSlotToOptions (durationFrom, availableTimeSlot) {
                let filteredArray =  availableTimeSlot.filter(function(timeSlot) {
                    let durationTo = moment.duration(timeSlot.value)
                    return durationTo.subtract(durationFrom).hours() >= 1
                })
                return filteredArray
            }
        },

        mounted () {
            this.scrollToTop()
            if(this.meetingRequestInfosProp){
                this.meetingRequestInfos = this.meetingRequestInfosProp

                $('#firstTimeSlotDate').val(this.meetingRequestInfos.firstTimeSlot.date)
                $('#secondTimeSlotDate').val(this.meetingRequestInfos.secondTimeSlot.date)
            }

            let availableDates = $.map(this.inspectorCalendarToJSON, function(value, key) {
                return key;
            });

            let datePickerInputs = ['first', 'second'];

            datePickerInputs.forEach(inputId => {
                $('#' + inputId + '_time_slot_date .input-group.date').datepicker({
                    keyboardNavigation: false,
                    forceParse: false,
                    autoclose: true,
                    format: "dd/mm/yyyy",
                    weekStart: 1,
                    beforeShowDay: function (date) {
                        let day = date.getFullYear() + "-" + ("0"+(date.getMonth()+1)).slice(-2) + "-" + ("0"+date.getDate()).slice(-2);
                        let isAvailable = availableDates.includes(day);

                        return {
                            'enabled' : isAvailable,
                            'tooltip' : isAvailable ? 'Disponible' : 'Non disponible'
                        }
                    },
                    language: 'fr',
                    constrainInput: true
                }).on(
                    'changeDate', () => {
                        let timeSlotDate = $('#' + inputId + 'TimeSlotDate').val()

                        let dateSplit = timeSlotDate.split('/')
                        let dateFormatted = dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0]
                        let availableTimeSlotJSON = this.inspectorCalendarToJSON[dateFormatted]
                        let availableTimeSlotStartArray = [];
                        let availableTimeSlotEndArray = [];

                        availableTimeSlotJSON.forEach( val => {
                            let timeSlotStart = val.start
                            let timeSlotEnd = val.end
                            let availableTimeSlotStart = {
                                value : timeSlotStart,
                                label : timeSlotStart.split(':')[0] + 'h' + timeSlotStart.split(':')[1]
                            }
                            let availableTimeSlotEnd = {
                                value : timeSlotEnd,
                                label : timeSlotEnd.split(':')[0] + 'h' + timeSlotEnd.split(':')[1]
                            }

                            availableTimeSlotStartArray.push(availableTimeSlotStart)
                            availableTimeSlotEndArray.push(availableTimeSlotEnd)
                        })

                        this.meetingRequestInfos[inputId + 'TimeSlot'].date = timeSlotDate
                        this.carizyInspectorTimeSlotOptions[inputId + 'Slot'].start = availableTimeSlotStartArray
                        this.carizyInspectorTimeSlotOptions[inputId + 'Slot'].end = availableTimeSlotEndArray
                    }
                );
            })

          if(
              this.vehicleInfosProp.availablePartners.inspector
          ){
            this.setExpert('carizy')
          }
        }
    }
</script>

<style scoped>
  
</style>